import type { CloverGatewayId } from './clover-system-constants';

export const CloverFrontendConfigEditingOutcome = {
    APPLIED: 'applied',
    INVALID_CONFIGURATION: 'invalid_configuration',
} as const;

export type CloverFrontendConfigEditingOutcome =
    (typeof CloverFrontendConfigEditingOutcome)[keyof typeof CloverFrontendConfigEditingOutcome];

export interface CloverFrontendConfigEditorValues {
    readonly enabled: boolean;
    readonly merchantId: string;
    readonly ecommerceApiBaseUrl: string;
    readonly ecommerceTokenizationUrl: string;
    readonly restPayDisplayApiBaseUrl: string;
}

export interface CloverFrontendConfigEditingRequestDetails {
    readonly gatewayId: typeof CloverGatewayId;
    readonly editorValues: CloverFrontendConfigEditorValues;
}

export interface CloverFrontendConfigEditingNormalizedResult {
    readonly gatewayId: typeof CloverGatewayId;
    readonly enabled: boolean;
    readonly merchantId: string;
    readonly ecommerceApiBaseUrl: string;
    readonly ecommerceTokenizationUrl: string;
    readonly restPayDisplayApiBaseUrl: string;
}

export type CloverFrontendConfigEditingResponseDetails =
    | {
          readonly outcome: typeof CloverFrontendConfigEditingOutcome.APPLIED;
          readonly normalizedResult: CloverFrontendConfigEditingNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverFrontendConfigEditingOutcome.INVALID_CONFIGURATION;
          readonly message: string;
          readonly body: unknown;
      };
